import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	/* justify-content: center; */
	width: 100%;
	background-color: #fafafa;
	height: 90vh;
	overflow-y: auto;
	padding: 18px 42px 40px;

	/* Chrome, Safari e Edge */
	&::-webkit-scrollbar {
		display: none;
	}

	/* Firefox */
	scrollbar-width: none;

	/* IE e Edge antigo */
	-ms-overflow-style: none;
`;
export const Content2 = styled.div`
	display: flex;
	width: 80%;
	flex-direction: column;
`;

export const Header = styled.header`
	display: flex;
	flex-direction: column;
	margin-bottom: 25px;
	width: 100%;
	max-width: 1160px;
	margin-left: auto;
	margin-right: auto;
`;

export const GoBack = styled.button`
	border: 0;
	background: transparent;
	color: #797d8d;
	padding: 0;
	display: flex;
	align-items: center;
	gap: 7px;
	font-size: 14px;
	font-family: "NotoSans-SemiBold";
	font-weight: 700;
	cursor: pointer;
	align-self: flex-start;
`;

export const Title = styled.h1`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 32px;
	font-weight: 700;
	color: #000e4b;
	margin: 17px 0 8px;
	letter-spacing: -0.5px;
	line-height: 1.1;
`;

export const Lead = styled.p`
	font-family: "NotoSans-Medium", sans-serif;
	color: #797d8d;
	margin: 0;
	font-size: 15px;
`;

export const Layout = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 2.05fr) minmax(300px, 1fr);
	gap: 20px;
	align-items: start;
	width: 100%;
	max-width: 1160px;
	margin: 0 auto;

	@media (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const LeftContent = styled.div`
	display: grid;
	gap: 19px;
`;

export const RightContent = styled.aside`
	display: grid;
	gap: 19px;

	@media (max-width: 900px) {
		grid-row: 1;
	}
`;
